module.exports = __webpack_public_path__ + "assets/img/errorTip.2fa190f2.png";